import { formatMoney, orderAmount, t } from '@aquabox/shared';
import { ChannelPill, PanelStagePill } from '../../components/Pills';
import type { Order } from '../../api/types';

function timeLabel(iso: string): string {
  return new Intl.DateTimeFormat('tr-TR', {
    timeZone: 'Europe/Istanbul',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(new Date(iso));
}

/**
 * "Son siparişler" kartı (panel §3.3 C).
 *
 * Panel siparişleri için eski "Panelde kapandı/Onaylandı" yerine `PanelStagePill` kullanılır —
 * panelin GERÇEK aşamasını rozet olarak gösterir (teslim edildi / iptal / yolda / yeni).
 * Bizim siparişler için araç plakası görünür.
 */
export function RecentOrdersCard({ orders }: { orders: Order[] }) {
  if (orders.length === 0) {
    return (
      <section className="card card-pad">
        <h2 className="section-title">{t('panel.recentOrders')}</h2>
        <p style={{ fontSize: 13, color: 'var(--text-secondary)', margin: '8px 0 0' }}>
          {t('panel.liveEmpty')}
        </p>
      </section>
    );
  }
  return (
    <section className="card card-pad">
      <h2 className="section-title" style={{ marginBottom: 12 }}>
        {t('panel.recentOrders')}
      </h2>
      <ul style={{ listStyle: 'none' }}>
        {orders.map((o) => {
          const isPanel = o.source === 'HAYAT_PANEL' || o.source === 'ABANT_PANEL';
          return (
            <li
              key={o.id}
              style={{
                display: 'grid',
                gridTemplateColumns: '60px 160px 1fr 120px 110px',
                gap: 12,
                alignItems: 'center',
                padding: '12px 4px',
                borderTop: '1px solid var(--border)',
                fontSize: 13.5,
              }}
            >
              <span style={{ color: 'var(--text-secondary)' }}>{timeLabel(o.receivedAt)}</span>
              <ChannelPill channel={o.channel} source={o.source} />
              <span
                style={{
                  fontWeight: 500,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {o.customerName}
              </span>
              <span style={{ textAlign: 'right', fontWeight: 600 }}>
                {formatMoney(orderAmount(o))}
              </span>
              {isPanel ? (
                <PanelStagePill source={o.source} raw={o.externalStatusRaw} />
              ) : (
                <span style={{ fontWeight: 600, color: 'var(--primary)' }}>
                  {o.vehicle?.plate ?? '—'}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
